export type { IVectoryProductsGetStockResponse } from '@shoprenterService/common/definitions'

export interface IContactUsInsertRequest {
  /** A megadott e-mail cím. */
  readonly email: string
  /** A megadott vezetéknév. */
  readonly lastName?: string
  /** A megadott keresztnév. */
  readonly firstName?: string
  /** A megadott telefonszám. */
  readonly phone?: string
  /** A megadott üzenet. */
  readonly message: string
}

export interface INewsletterInsertRequest {
  /** A megadott vezetéknév. */
  readonly lastName: string
  /** A megadott keresztnév. */
  readonly firstName: string
  /** A megadott e-mail cím. */
  readonly email: string
}

export interface IBaseCategory {
  /** A kategória base64-elt azonosítója. */
  readonly id: string
  /** A kategória neve. */
  readonly name: string
}

export interface ICategory extends IBaseCategory {
  /** Létrehozás időpontja. */
  readonly createdAt: string
}

export type TCategories = readonly ICategory[]

export interface IProductCategory {
  /** A kategória base64-elt azonosítója. */
  readonly categoryId: string
  /** A termék cikkszáma. */
  readonly sku: string
}

export type TProductCategories = readonly IProductCategory[]

export interface IBaseProduct {
  /** A termék cikkszáma. */
  readonly sku: string
  /** A termék neve. */
  readonly name: string
  /** A termékhez tartozó leírás. */
  readonly description: string
  /** A termék nettó ára. */
  readonly netPrice: number
  /** A termék bruttó ára. */
  readonly grossPrice: number
  /** Termékhez tartozó youtube link, nem kötelező. */
  readonly youtubeLink: string | null
  /** A termék taneszköz webshopon lévő linkje. */
  readonly link: string
  /** Mennyi termék van készleten? */
  readonly stock: number
  /** A termék kiemelt termék? */
  readonly isTopProduct: 0 | 1
  /** Hány darabból áll a termék? */
  readonly pieces: number
}

export interface IProduct extends IBaseProduct {
  /** Létrehozás időpontja. */
  readonly createdAt: string
}

export type TProducts = readonly IProduct[]

export interface IDigestProduct extends IProduct {
  /** A termékhez tartozó képek url címei. */
  readonly images: readonly string[]
  /** A termék leírásából az első tag outerHTML tartalma. */
  readonly shortDescription: string
  /** A termék leírásának a maradék része (`description` - `shortDescription`).  */
  readonly restDescription: string
}

export type TDigestProducts = readonly IDigestProduct[]

export interface IExtendedProduct extends IDigestProduct {
  /** A termékhez tartozó kategóriák nevei. */
  readonly categories: readonly string[]
  /** A termékhez kapcsolódó termékek adatai. */
  readonly relatedProducts: TDigestProducts
}

export interface IProductImage {
  /** A termék cikkszáma. */
  readonly sku: string
  /** Az adott termékhez tarozó kép url-je. */
  readonly imagePath: string
}

export type TProductImages = readonly IProductImage[]

export interface IRelatedProduct {
  /** Az eredeti termék cikkszáma. */
  readonly sku: string
  /** Az eredeti termékhez kapcsoló termék cikkszáma. */
  readonly relatedSku: string
}

export type TRelatedProducts = readonly IRelatedProduct[]

export enum EContactUsRoute {
  Insert = '/api/contact-us'
}

export enum ENewsletterRoute {
  Insert = '/api/newsletter'
}

export enum EProductRoute {
  Refresh     = '/api/products/refresh',
  GetProduct  = '/api/products/:sku',
  GetProducts = '/api/products',
  TopProducts = '/api/products/top-products'
}

export interface IProductsGetTopProductsResponse {
  readonly topProducts: TDigestProducts
}

export interface IProducsFilters {
  /** Minimum mennyi építő elemből áll a termék. */
  readonly minPiece?: number
  /** Maximum mennyi építő elemből áll a termék. */
  readonly maxPiece?: number
  /** Minimum termék bruttó ár. */
  readonly minPrice?: number
  /** Maximum termék bruttó ár. */
  readonly maxPrice?: number
  /** Termék adatok közötti keresés. */
  readonly search?: string
}

export interface IProductsGetQueryParams extends IProducsFilters {
  /** Termék kategória neve. */
  readonly categoryName?: string
}

export interface IProductsGetResponse {
  readonly products: TDigestProducts
}

export interface IProductGetResponse {
  readonly product: IExtendedProduct
}

export enum ECategoryRoute {
  Get = '/api/categories'
}

export interface ICategoryGetAllResponse {
  readonly categories: TCategories
}
